var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mw-editor',{model:{value:(_vm.question.content),callback:function ($$v) {_vm.$set(_vm.question, "content", $$v)},expression:"question.content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }